module.exports = __webpack_public_path__ + "img/write_small.7832902f.webp";